export default __webpack_public_path__ + "static/media/plan4-col6-img.97578fec.svg";